import React, { useState } from "react";

export default function HarvestFarmPicker({ catalog, ghse, onChange, disabled }) {
  const farmKey = (g) => String(g.farm_id ?? g.farm__name);
  const [farm, setFarm] = useState(() => {
    const selected = catalog.ghses.find((g) => String(g.id) === String(ghse));
    return selected ? farmKey(selected) : "";
  });
  const farms = [...new Map(catalog.ghses.map((g) => [farmKey(g), g.farm__name])).entries()];
  const greenhouses = catalog.ghses.filter((g) => farmKey(g) === farm);
  const selected = greenhouses.find((g) => String(g.id) === String(ghse));
  const zones = [...new Set(greenhouses.map((g) => g.zone__name || "Unassigned zone"))].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  return (
    <div className="qr-farm-workspace">
      {!farm ? (
        <>
          <p className="qr-eyebrow">01 / CHOOSE YOUR FARM</p>
          <h3>Where are you harvesting today?</h3>
          <div className="qr-farm-cards">
            {farms.map(([id, name]) => (
              <button type="button" key={id} disabled={disabled} onClick={() => setFarm(id)}>
                <strong>{name}</strong>
                <span>{catalog.ghses.filter((g) => farmKey(g) === id).length} greenhouses · Enter farm →</span>
              </button>
            ))}
          </div>
          {!farms.length && <p>No greenhouses are available.</p>}
        </>
      ) : (
        <>
          <div className="qr-farm-banner">
            <div><small>YOUR FARM WORKSPACE</small><strong>{farms.find(([id]) => id === farm)?.[1]}</strong></div>
            <button type="button" disabled={disabled} onClick={() => { onChange(""); setFarm(""); }}>Change farm</button>
          </div>
          <label className="qr-ghse-dropdown">Greenhouse
            <select value={ghse} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
              <option value="">Select GHSE · grouped by zone</option>
              {zones.map((zone) => {
                const members = greenhouses.filter((g) => (g.zone__name || "Unassigned zone") === zone).sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
                const title = /^zone\b/i.test(zone) || zone === "Unassigned zone" ? zone : `Zone ${zone}`;
                return <optgroup key={zone} label={`${title} · ${members.length} GHSEs`}>
                  {members.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
                </optgroup>;
              })}
            </select>
          </label>
          {selected && <small className="qr-selected-zone">{selected.zone__name || "Unassigned zone"} / {selected.name}</small>}
        </>
      )}
    </div>
  );
}
